import { ProctorTypeLabel, type ProctorTypeLabelVariant } from '@exam-center/proctor-management';
import { ChipGroup, type GridColDef, Text } from '@shared/components';
import { formatDateTime } from '@shared/utils';

export interface AdminProctorListItem {
  id: string;
  fullName: string;
  type: ProctorTypeLabelVariant;
  examCenter: string;
  createdAt: Date;
}

export const columns: GridColDef<AdminProctorListItem>[] = [
  {
    field: 'name',
    headerName: 'ชื่อผู้คุมสอบ',
    sortable: false,
    flex: 1,
    renderCell: ({ row }) => {
      return <Text>{row.fullName}</Text>;
    },
  },
  {
    field: 'type',
    headerName: 'ประเภทผู้คุมสอบ',
    width: 180,
    sortable: false,
    renderCell: ({ row }) => {
      return <ProctorTypeLabel variant={row.type} />;
    },
  },
  {
    field: 'examCenter',
    headerName: 'ศูนย์ทดสอบ',
    width: 160,
    sortable: false,
    renderCell: ({ row }) => {
      const { examCenter } = row;

      if (examCenter && examCenter.length === 0) {
        return <Text>-</Text>;
      } else {
        return <ChipGroup labels={[examCenter ?? '-']} limit={3} direction='row' />;
      }
    },
  },
  {
    field: 'createdAt',
    headerName: 'วันที่อนุมัติคำขอ',
    width: 160,
    renderCell: ({ row }) => {
      return <Text>{formatDateTime(row.createdAt)}</Text>;
    },
  },
];
